import { Check, Square } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const BRANDING_OPTIONS = [
  { value: "both", label: "Kavach Box + Shree Finserv" },
  { value: "shree_finserv", label: "Shree Finserv only" },
];

export const BrandingSelect = ({ value, onChange, testId }) => (
  <Select value={value || ""} onValueChange={onChange}>
    <SelectTrigger
      data-testid={testId}
      className={`h-9 rounded-lg text-xs font-semibold transition-colors ${value ? "border-[#C9D4E6] bg-white text-[#1B2A4A]" : "border-dashed border-[#D4A017] bg-[#D4A017]/10 text-[#A87608]"}`}
    >
      <SelectValue placeholder="Choose branding" />
    </SelectTrigger>
    <SelectContent>
      {BRANDING_OPTIONS.map((o) => (
        <SelectItem key={o.value} value={o.value} data-testid={`${testId}-option-${o.value}`}>{o.label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

const SUMMARY = [
  ["both", "Kavach Box + Shree Finserv", "bg-[#1B2A4A] text-white"],
  ["shree_finserv", "Shree Finserv only", "bg-[#D4A017]/15 text-[#7A5606]"],
  ["none", "Branding not chosen", "bg-white border border-dashed border-[#D4A017] text-[#A87608]"],
];

export const BrandingSummary = ({ counts, sentCounts }) => (
  <div className="flex flex-wrap gap-2 mb-4" data-testid="gift-branding-summary">
    {SUMMARY.map(([key, label, cls]) => (
      <span key={key} className={`px-3 py-1.5 rounded-full text-xs font-semibold ${cls}`} data-testid={`gift-branding-count-${key}`}>
        {label}: {counts?.[key] ?? 0}
      </span>
    ))}
    <span className="hidden sm:block w-px bg-[#C9D4E6] mx-1" aria-hidden="true" />
    <span className="px-3 py-1.5 rounded-full text-xs font-semibold bg-emerald-600 text-white" data-testid="gift-sent-count">Sent: {sentCounts?.sent ?? 0}</span>
    <span className="px-3 py-1.5 rounded-full text-xs font-semibold bg-white border border-[#C9D4E6] text-[#3A4557]" data-testid="gift-not-sent-count">Not sent yet: {sentCounts?.not_sent ?? 0}</span>
  </div>
);

const barBtn = "rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors disabled:opacity-50";

export const BulkBrandingBar = ({ count, onApply, onSent, onCancel, busy }) => (count > 0 ? (
  <div className="sticky top-[68px] z-30 mb-3 flex flex-wrap items-center gap-2 rounded-xl bg-[#1B2A4A] px-4 py-3 text-white shadow-lg animate-in fade-in slide-in-from-top-2 duration-200" data-testid="gift-bulk-bar">
    <span className="mr-auto text-sm font-semibold" data-testid="gift-selected-count">{count} selected</span>
    <span className="text-xs text-white/70">Set branding:</span>
    {BRANDING_OPTIONS.map((o) => (
      <button key={o.value} onClick={() => onApply(o.value)} disabled={busy} data-testid={`gift-bulk-${o.value}-btn`} className={`${barBtn} bg-white/10 hover:bg-white/20`}>
        {o.label}
      </button>
    ))}
    <span className="w-px self-stretch bg-white/20 mx-1" aria-hidden="true" />
    <button onClick={() => onSent(true)} disabled={busy} data-testid="gift-bulk-sent-btn" className={`${barBtn} bg-emerald-500 hover:bg-emerald-400 text-white`}>Mark sent</button>
    <button onClick={() => onSent(false)} disabled={busy} data-testid="gift-bulk-not-sent-btn" className={`${barBtn} bg-white/10 hover:bg-white/20`}>Mark not sent</button>
    <button onClick={onCancel} data-testid="gift-bulk-cancel-btn" className="px-2 py-1.5 text-xs text-white/70 transition-colors hover:text-white">Cancel</button>
  </div>
) : null);

const shortDate = (iso) => new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short" });

export const SentToggle = ({ sentAt, onToggle, testId }) => (sentAt ? (
  <button onClick={() => onToggle(false)} data-testid={testId} title="Click to mark as not sent"
    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-semibold transition-colors">
    <Check className="h-3.5 w-3.5" /> Sent {shortDate(sentAt)}
  </button>
) : (
  <button onClick={() => onToggle(true)} data-testid={testId}
    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-emerald-600/40 text-emerald-700 hover:bg-emerald-50 text-xs font-semibold transition-colors">
    <Square className="h-3.5 w-3.5" /> Mark sent
  </button>
));
